import { usePathname } from "next/navigation";
import { useEffect } from "react";

import { SubscriptionUpdatedEventPayload } from "~/components/Docusign/types";
import {
  useFetchSubscription,
  useInvalidateSubscription,
} from "~/components/Subscription/hooks/useFetchSubscription";
import { useSubscriptionStore } from "~/components/Subscription/store";

import useCurrentOrganization from "~/lib/organizations/hooks/use-current-organization";
import { SocketEvents } from "~/lib/socket/constants";
import { useSocketConnection } from "~/lib/socket/hooks/useSocketConnection";

export const useSubscriptionWrapper = () => {
  const pathname = usePathname();
  const { setSubscription, setIsLoading } = useSubscriptionStore();
  const { data: subscription, isLoading, refetch } = useFetchSubscription();
  const invalidateSubscription = useInvalidateSubscription();

  useEffect(() => {
    setIsLoading(isLoading);

    if (subscription) {
      setSubscription(subscription);
    }
  }, [isLoading, subscription, setSubscription, setIsLoading]);

  useEffect(() => {
    refetch();
  }, [pathname, refetch]);

  // socket event for subscription update
  const currentOrg = useCurrentOrganization();
  const event = SocketEvents.subscription.updated;
  const room = `${event}:room:${currentOrg?.org_id}`;
  useSocketConnection<SubscriptionUpdatedEventPayload>({
    event,
    room,
    messageCallback: ({ data }) => {
      invalidateSubscription();
    },
  });

  return {
    subscription,
    isLoading,
  };
};
